import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const styles = {};

const enhance = compose();

const ShopTableHead = enhance(() => {
  return (
    <TableHead>
      <TableRow>
        <TableCell />
        <TableCell>店舗名</TableCell>
        <TableCell>住所</TableCell>
        <TableCell>電話番号</TableCell>
        <TableCell />
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(ShopTableHead);
